import { createSlice } from "@reduxjs/toolkit";
import { IContacts } from "src/page-components/contact-us/types";
import { CONTACT_US_SLICE_NAME } from "./actions";
import { getContactListReducer, submitContactFormReducer } from "./reducers";

export interface IContactUsState {
  isLoading: boolean;
  isLoadingContacts: boolean;
  contacts: IContacts;
}

const initialState: IContactUsState = {
  isLoading: false,
  isLoadingContacts: true,
  contacts: null,
};

export const { reducer: contactUs } = createSlice({
  name: CONTACT_US_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    submitContactFormReducer(builder);
    getContactListReducer(builder);
  },
});
